// extracted by mini-css-extract-plugin
export default {"testimonialWrapper":"styles_testimonialWrapper__snqre","testimonial":"styles_testimonial__II4Ow","person":"styles_person__9avez","position":"styles_position__hobKi"};